import { Route } from '@angular/router'
import { superAdminGuard } from '@baboor/baboor-auth'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type AdminRoutes = {
    adminLogin: Route
    adminDashboard: Route
    adminShops: Route
    adminUsers: Route
    adminAdmins: Route
    adminPlans: Route
    adminUserlist: Route
}

const superAdminGuardWithLogin = superAdminGuard({
    redirectTo: ['/dashboard/home'],
    loginPath: '/admin-login',
})

export const adminRoutes: AdminRoutes = {
    adminLogin: {
        // Dedicated super-admin sign-in, separate from the customer/vendor
        // login at /login. It authenticates against /v1/admin/login, which
        // rejects anything that is not in the super-admin group.
        path: 'admin-login',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageAdminLoginComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
        data: {
            title: 'Hair Style Club | Admin Sign In',
            defaultReturnUrl: '/admin',
        },
    },
    adminDashboard: {
        // Routes are flattened at the top level of app.routes.ts, so the
        // dashboard must live at the literal 'admin' path (=> /admin).
        path: 'admin',
        pathMatch: 'full',
        canActivate: [superAdminGuardWithLogin],
        loadComponent: () =>
            import('./page-super-admin-dashboard/page-super-admin-dashboard.component').then(
                (m) => m.PageSuperAdminDashboardComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Admin) },
    },
    adminShops: {
        path: 'admin/shops',
        canActivate: [superAdminGuardWithLogin],
        loadComponent: () =>
            import('./page-super-admin-shops/page-super-admin-shops.component').then(
                (m) => m.PageSuperAdminShopsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Admin) },
    },
    adminUsers: {
        path: 'admin/users',
        canActivate: [superAdminGuardWithLogin],
        loadComponent: () =>
            import('./page-super-admin-users/page-super-admin-users.component').then(
                (m) => m.PageSuperAdminUsersComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Admin) },
    },
    adminAdmins: {
        // Super Admin user management, backed by RestAuth group membership.
        path: 'admin/admins',
        canActivate: [superAdminGuardWithLogin],
        loadComponent: () =>
            import('./page-super-admin-admins/page-super-admin-admins.component').then(
                (m) => m.PageSuperAdminAdminsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Admin) },
    },
    adminPlans: {
        path: 'admin/plans',
        canActivate: [superAdminGuardWithLogin],
        loadComponent: () =>
            import('./page-super-admin-plans/page-super-admin-plans.component').then(
                (m) => m.PageSuperAdminPlansComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Admin) },
    },
    adminUserlist: {
        path: 'admin-userlist',
        canActivate: [superAdminGuardWithLogin],
        loadComponent: () =>
            import('../page-admin-userlist/page-admin-userlist.component').then(
                (m) => m.PageAdminUserlistComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Default) },
    },
}
